/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Scroll_To_BottomInputs */



/**
* | output |
* | --- |
* | "Scroll to latest message" |
*
* @param {Chat_Scroll_To_BottomInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_scroll_to_bottom = /** @type {((inputs?: Chat_Scroll_To_BottomInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Scroll_To_BottomInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zur neuesten Nachricht springen")
	return /** @type {LocalizedString} */ ("Scroll to latest message")
});